import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppConfigService } from '../app-config.service.service';

@Injectable({
  providedIn: 'root'
})
export class SystemComponentService {

  private baseurl = "";// `${environment.apiUrl}`;
  apiroute = "/FlexIntegration";

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    this.baseurl = this.appConfigService.apiBaseUrl;
  }

  SaveDocument(filestring, id) {
    return this.http.post(this.baseurl + '/DownloadFile/Upload', { filestring: filestring, doctype: 'component', id: id })
  }

  GetComponentsFileNames() {
    // return this.http.post<any>(this.baseurl + '/DownloadFile/GetComponentsFileNames', {})
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_EstmateSVG'});
  }

  GetComponentsFileNamesSvg(id) {
    // return this.http.post<any>(this.baseurl + '/DownloadFile/GetComponentsFileNames', {})
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_EstmateSVG', projectrfiid: id});
  }

  GetComponentsFileNamesSvgMaster(id) {
    // return this.http.post<any>(this.baseurl + '/DownloadFile/GetComponentsFileNames', {})
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_EstmateSVGMaster', projectrfiid: id});
  }

  Get_EstmateSVG_Master() {
    // return this.http.post<any>(this.baseurl + '/DownloadFile/Get_EstmateSVG_Master', {})
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_EstmateSVG_Master'});
  }

  Get_ProjectPartDetailSugestedValues() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_ProjectPartDetailSugestedValues', partnumber: 20836 });
  }


  Get_ComponentDetailsCE(id) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_ComponentDetailsByIdCE', componentid: id });
  }

  Get_ComponentDetailsCEMaster(id) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_ComponentDetailsByIdCEMaster', componentid: id });
  }

  Get_ComponentsByIdCE(id) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_ComponentsByIdCE', componentid: id });
  }

  Get_ComponentsByIdCEMaster(id) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_ComponentsByIdCEMaster', componentid: id });
  }

  Get_ComponentDetailsByIdfromMaster(id) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_ComponentDetailsByIdfromMaster', componentid: id });
  }

  Get_ComponentsByIds(id) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_ComponentsByIdCE-2', componentid: id });
  }

  Get_ComponentsByIdCE_Master(id) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_ComponentsByIdCE_Master', componentid: id });
  }

  Get_ECOMMComponentsByIdCE2(id) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_ECOMMComponentsByIdCE-2', componentid: id });
  }

  Get_ComponentsByIdsMaster(id) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_ComponentsByIdCE-2Master', componentid: id });
  }

  Get_ComponentsByIdsFromMaster(id) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_ComponentDetailsByIdfromMaster', componentid: id });
  }

  Get_EstimatesystemDrawingjason(id) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_EstimatesystemDrawingjason', systemid: id });
  }

  InsertUpdate_EstimatesystemDrawingjason(id, drawingjason) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'InsertUpdate_EstimatesystemDrawingjason', systemid: id, drawingjason: drawingjason });
  }

  Get_EstimateLibComponentsType() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_EstimateLibComponentsType' });
  }

  Get_EstimateLibComponentsTypeMaster() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_EstimateLibComponentsTypeMaster' });
  }

  Get_EstimateLibComponentsTypeFromMaster() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_EstimateLibComponentsTypefromMaster' });
  }

  Get_EstimateLibComponentsTypeClient(dbcode) {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_EstimateLibComponentsTypeClient', dbcode: dbcode });
  }

  Get_EstimateLibComponentsTypeSVG() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_EstimateMasterComponentsType' });
  }

  Get_EstimateLibComponentsTypeSVGMaster() {
    return this.http.post<any>(this.baseurl + this.apiroute, { 'method': 'Get_EstimateLibComponentsTypefromMaster' });
  }
  
  Get_ApplicationNotesActive(applicationName) {
    let model = {
      'method': 'Get_ApplicationNotesActive',
      applicationName: applicationName
    }

    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  Get_MasterApplicationNotesAll(applicationName) {
    let model = {
      'method': 'Get_MasterApplicationNotesAll',
      applicationName: applicationName
    }

    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  Get_ApplicationNotesWithTerminals(applicationName) {
    let model = {
      'method': 'Get_ApplicationNotesWithTerminals',
      applicationName: applicationName
    }

    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  Get_ApplicationNotesActiveMaster(applicationName) {
    let model = {
      'method': 'Get_ApplicationNotesActiveMaster',
      applicationName: applicationName
    }

    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  Get_MasterApplicationNotesActive(applicationName) {
    let model = {
      'method': 'Get_MasterApplicationNotesActive',
      applicationName: applicationName
    }

    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  Get_ApplicationNotesActiveTop(applicationName) {
    let model = {
      'method': 'Get_ApplicationNotesActiveTop',
      applicationName: applicationName
    }

    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  Get_WiringdiagramListCE() {
    let model = {
      'method': 'Get_WiringdiagramListCE'
    }
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  Get_WiringdiagramListCEMaster() {
    let model = {
      'method': 'Get_WiringdiagramListCEMaster'
    }
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  Get_WiringdiagramPartCE(id) {
    let model = {
      'method': 'Get_WiringdiagramPartCE',
      wiringdetailid: id
    }
    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  Get_WiringdiagramPartCEMaster(id) {
    let model = {
      'method': 'Get_WiringdiagramPartCEMaster',
      wiringdetailid: id
    }
    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  InsertUpadte_WiringDiagramCE(id, partdwgrefference, partdwgrefferencename, partdwgrefferencedesc, active, partjumper, 
    partcable, partcommisioning, wdrefpartid, wdfilepath, numberofwires, showshield, shield) {
    let model = {
      'method': 'InsertUpadte_WiringDiagramCE',
      id: id,
      partdwgrefference: partdwgrefference,
      partdwgrefferencename: partdwgrefferencename,
      partdwgrefferencedesc: partdwgrefferencedesc,
      active: active == true ? 1 : 0,
      partjumper: partjumper,
      partcable: partcable,
      partcommisioning: partcommisioning,
      wdrefpartid: wdrefpartid,
      wdfilepath: wdfilepath,
      clearrecords:1,
      numberofwires:numberofwires,
      showshield:showshield,
      shield:shield
    }

    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  InsertUpadte_WiringDiagramCEnew(id, partdwgrefference, partdwgrefferencename, partdwgrefferencedesc, active, partjumper, 
    partcable, partcommisioning, wdrefpartid, wdfilepath, numberofwires, showshield, shield, powerfrom) {
    let model = {
      'method': 'InsertUpadte_WiringDiagramCE',
      id: id,
      partdwgrefference: partdwgrefference,
      partdwgrefferencename: partdwgrefferencename,
      partdwgrefferencedesc: partdwgrefferencedesc,
      active: active == true ? 1 : 0,
      partjumper: partjumper,
      partcable: partcable,
      partcommisioning: partcommisioning,
      wdrefpartid: wdrefpartid,
      wdfilepath: wdfilepath,
      clearrecords:1,
      numberofwires:numberofwires,
      showshield:showshield,
      shield:shield,
      powerfrom:powerfrom
    }

    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  InsertUpadte_WiringDiagramCEMaster(id, partdwgrefference, partdwgrefferencename, partdwgrefferencedesc, active, partjumper, 
    partcable, partcommisioning, wdrefpartid, wdfilepath, numberofwires, showshield, shield) {
    let model = {
      'method': 'InsertUpadte_WiringDiagramCEMaster',
      id: id,
      partdwgrefference: partdwgrefference,
      partdwgrefferencename: partdwgrefferencename,
      partdwgrefferencedesc: partdwgrefferencedesc,
      active: active == true ? 1 : 0,
      partjumper: partjumper,
      partcable: partcable,
      partcommisioning: partcommisioning,
      wdrefpartid: wdrefpartid,
      wdfilepath: wdfilepath,
      clearrecords:1,
      numberofwires:numberofwires,
      showshield:showshield,
      shield:shield
    }

    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  InsertUpadte_WiringDiagramCE2(id, partdwgrefference, partdwgrefferencename, partdwgrefferencedesc, active, partjumper, partcable, partcommisioning, wdrefpartid, wdfilepath) {
    let model = {
      'method': 'InsertUpadte_WiringDiagramCE',
      id: id,
      partdwgrefference: partdwgrefference,
      partdwgrefferencename: partdwgrefferencename,
      partdwgrefferencedesc: partdwgrefferencedesc,
      active: active == true ? 1 : 0,
      partjumper: partjumper,
      partcable: partcable,
      partcommisioning: partcommisioning,
      wdrefpartid: wdrefpartid,
      wdfilepath: wdfilepath,
    }

    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  InsertUpdate_ComponentCE(id, name, systemtypeid, image, active, compscope, deleted, tag, svg) {
    let model = {
      'method': 'InsertUpdate_ComponentCE',
      name: name,
      systemtypeid: systemtypeid,
      image: image,
      active: active,
      compscope: compscope,
      deleted: deleted,
      tag: tag,
      svg: svg,
      id: id,
    }

    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  InsertUpdate_ComponentCEMaster(id, name, systemtypeid, image, active, compscope, deleted, tag, svg) {
    let model = {
      'method': 'InsertUpdate_ComponentCEMaster',
      name: name,
      systemtypeid: systemtypeid,
      image: image,
      active: active,
      compscope: compscope,
      deleted: deleted,
      tag: tag,
      svg: svg,
      id: id,
    }

    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  InsertUpdate_ComponentfromMaster(id, name, systemtypeid, image, active, compscope, deleted, tag, svg) {
    let model = {
      'method': 'InsertUpdate_ComponentfromMaster',
      name: name,
      systemtypeid: systemtypeid,
      image: image,
      active: active,
      compscope: compscope,
      deleted: deleted,
      tag: tag,
      svg: svg,
      id: id,
    };
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  InsertUpdate_ComponentCE2(id, name, systemtypeid, image, active, compscope, deleted, tag, svg,visio,notshowiddwg) {
    let model = {
      'method': 'InsertUpdate_ComponentCE',
      name: name,
      systemtypeid: systemtypeid,
      image: image, //hacer split para enviar solo el nombre
      active: active,
      compscope: compscope,
      deleted: deleted,
      tag: tag,
      svg: svg,
      id: id,
      visiofilename: visio,
      notshowindwg:notshowiddwg == true ? 1 : 0
    }

    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }


  InsertUpdate_ComponentCE3(id, name, systemtypeid, image, active, compscope, deleted, tag, svg,visio,notshowiddwg, aplicationtypeid,
    notschematic) {
    let model = {
      'method': 'InsertUpdate_ComponentCE',
      name: name,
      systemtypeid: systemtypeid,
      image: image, //hacer split para enviar solo el nombre
      active: active,
      compscope: compscope,
      deleted: deleted,
      tag: tag,
      svg: svg,
      id: id,
      visiofilename: visio,
      notshowindwg:notshowiddwg == true ? 1 : 0,
      aplicationtypeid:aplicationtypeid,
      notschematic:notschematic
    }

    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  InsertUpdate_ComponentCE3Master(id, name, systemtypeid, image, active, compscope, deleted, tag, svg,visio,notshowiddwg, aplicationtypeid,
    notschematic) {
    let model = {
      'method': 'InsertUpdate_ComponentCEMaster',
      name: name,
      systemtypeid: systemtypeid,
      image: image, //hacer split para enviar solo el nombre
      active: active,
      compscope: compscope,
      deleted: deleted,
      tag: tag,
      svg: svg,
      id: id,
      visiofilename: visio,
      notshowindwg:notshowiddwg == true ? 1 : 0,
      aplicationtypeid:aplicationtypeid,
      notschematic:notschematic
    }

    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  InsertUpdate_ComponentCE3Client(id, name, systemtypeid, image, active, compscope, deleted, tag, svg,visio,notshowiddwg, aplicationtypeid, notschematic, dbcode) {
    let model = {
      'method': 'InsertUpdate_ClientComponent',
      name: name,
      systemtypeid: systemtypeid,
      image: image, //hacer split para enviar solo el nombre
      active: active,
      compscope: compscope,
      deleted: deleted,
      tag: tag,
      svg: svg,
      id: id,
      visiofilename: visio,
      notshowindwg:notshowiddwg == true ? 1 : 0,
      aplicationtypeid:aplicationtypeid,
      notschematic:notschematic,
      dbcode: dbcode
    }

    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }



  InsertUpdate_ComponentDetailCE(id, estcompid, appnoteid, pointtypeid, partid, partqty, pointnumber, instantid, deleted, ctag, wddetailid) {
    let model = {
      'method': 'InsertUpdate_ComponentDetailCE',
      estcompid: estcompid,
      appnoteid: appnoteid,
      pointtypeid: pointtypeid,
      partid: partid,
      partqty: partqty,
      pointnumber: pointnumber,
      instantid: instantid,
      deleted: deleted,
      ctag: ctag,
      wddetailid: wddetailid,
      id: id,
    }

    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  InsertUpdate_ComponentDetailCEMaster(id, estcompid, appnoteid, pointtypeid, partid, partqty, pointnumber, instantid, deleted, ctag, wddetailid) {
    let model = {
      'method': 'InsertUpdate_ComponentDetailCEMaster',
      estcompid: estcompid,
      appnoteid: appnoteid,
      pointtypeid: pointtypeid,
      partid: partid,
      partqty: partqty,
      pointnumber: pointnumber,
      instantid: instantid,
      deleted: deleted,
      ctag: ctag,
      wddetailid: wddetailid,
      id: id,
    }

    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  InsertUpdate_ComponentDetailLaborWeightCE(id, estcompid, appnoteid, pointtypeid, partid, partqty, pointnumber, instantid, deleted, ctag, wddetailid) {
    let model = {
      'method': 'InsertUpdate_ComponentDetailLaborCE',
      estcompid: estcompid,
      appnoteid: appnoteid,
      pointtypeid: pointtypeid,
      partid: partid,
      partqty: partqty,
      pointnumber: pointnumber,
      instantid: instantid,
      deleted: deleted == true || deleted == 1 ? 1 : 0,
      ctag: ctag,
      wddetailid: wddetailid,
      id: id,
    }

    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  InsertUpdate_ComponentDetailLaborWeightCEMaster(id, estcompid, appnoteid, pointtypeid, partid, partqty, pointnumber, instantid, deleted, ctag, wddetailid) {
    let model = {
      'method': 'InsertUpdate_ComponentDetailLaborCEMaster',
      estcompid: estcompid,
      appnoteid: appnoteid,
      pointtypeid: pointtypeid,
      partid: partid,
      partqty: partqty,
      pointnumber: pointnumber,
      instantid: instantid,
      deleted: deleted == true || deleted == 1 ? 1 : 0,
      ctag: ctag,
      wddetailid: wddetailid,
      id: id,
    }

    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  InsertUpdate_ComponentDetailLaborWeightCEMultiple(id, estcompid, appnoteid, pointtypeid, partid, partqty, pointnumber, instantid, deleted, ctag, wddetailid) {
    let model = {
      'method': 'UpdateMultiple_ComponentDetailLaborCE',
      estcompid: estcompid,
      appnoteid: appnoteid,
      pointtypeid: pointtypeid,
      partid: partid,
      partqty: partqty,
      pointnumber: pointnumber,
      instantid: instantid,
      deleted: deleted == true || deleted == 1 ? 1 : 0,
      ctag: ctag,
      wddetailid: wddetailid,
      ids: id,
    }

    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  InsertUpdate_ComponentDetailLaborWeightCEMultipleMaster(id, estcompid, appnoteid, pointtypeid, partid, partqty, pointnumber, instantid, deleted, ctag, wddetailid) {
    let model = {
      'method': 'UpdateMultiple_ComponentDetailLaborCEMaster',
      estcompid: estcompid,
      appnoteid: appnoteid,
      pointtypeid: pointtypeid,
      partid: partid,
      partqty: partqty,
      pointnumber: pointnumber,
      instantid: instantid,
      deleted: deleted == true || deleted == 1 ? 1 : 0,
      ctag: ctag,
      wddetailid: wddetailid,
      ids: id,
    }

    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  Get_EstimateJumper() {
    let model = {
      'method': 'Get_EstimateJumper'
    }
    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  Get_EstimateJumperMaster() {
    let model = {
      'method': 'Get_EstimateJumperMaster'
    }
    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  Insert_EstimateJumperType(id, name) {
    let model = {
      'method': 'Insert_EstimateJumperType',
      id: id,
      name: name
    }
    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  Insert_EstimateJumperTypeMaster(id, name) {
    let model = {
      'method': 'Insert_EstimateJumperTypeMaster',
      id: id,
      name: name
    }
    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  Insert_EstimateCableType(id, name, partid) {
    let model = {
      'method': 'Insert_EstimateCableType',
      id: id,
      name: name,
      partid: partid
    }
    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  Insert_EstimateCableTypeMaster(id, name) {
    let model = {
      'method': 'Insert_EstimateCableTypeMaster',
      id: id,
      name: name
    }
    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  Get_EstimateCable() {
    let model = {
      'method': 'Get_EstimateCable'
    }
    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  Get_EstimateCableMaster() {
    let model = {
      'method': 'Get_EstimateCableMaster'
    }
    console.log(model);
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  InsertUpdate_ComponentTypeCE(id, componentname, parentid) {
    let model = {
      'method': 'InsertUpdate_ComponentTypeCE',
      componentname: componentname,
      parentid: parentid,
      componenttypeid:id
    }
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  InsertUpdate_ComponentTypeCEStencil(id, componentname, parentid, stencil) {
    let model = {
      'method': 'InsertUpdate_ComponentTypeCE',
      componentname: componentname,
      parentid: parentid,
      componenttypeid:id,
      visiofilename:stencil
    }
    console.log(model)
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  InsertUpdate_ComponentTypeCEStencilMaster(id, componentname, parentid, stencil) {
    let model = {
      'method': 'InsertUpdate_ComponentTypeCEMaster',
      componentname: componentname,
      parentid: parentid,
      componenttypeid:id,
      visiofilename:stencil
    }
    console.log(model)
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  InsertUpdate_ComponentTypefromMaster(id, componentname, parentid, stencil) {
    let model = {
      'method': 'InsertUpdate_ComponentTypefromMaster',
      componentname: componentname,
      parentid: parentid,
      componenttypeid: id,
      visiofilename: stencil
    };
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }

  InsertUpdate_ComponentTypeCEStencilClient(dbcode, id, componentname, parentid, stencil) {
    let model = {
      'method': 'Insert_ComponentTypeInClient',
      dbcode: dbcode,
      componentname: componentname,
      parentid: parentid,
      componenttypeid: id,
      visiofilename:stencil
    }
    console.log(model)
    return this.http.post<any>(this.baseurl + this.apiroute, model);
  }


}
